import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;
declare function initiateDragDropQuestion(): any;
@Component({
  selector: 'app-dragdrop',
  templateUrl: './dragdrop.html',
  styleUrls: ['./dragdrop.scss']
})

export class DragDrop implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public questionId = 0;
  public allClosed = true;
  public dragdropresponse = "";

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadAnswersSubscription = this.dataSvc.getLoadDragDropAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.dragdropresponse = "";
  }

  loadAnswers() {
    this.resetVariables();
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 7) return;

    if(this.dataSvc.currentQuestion().Question.OriginalAnswer == null || 
      this.dataSvc.currentQuestion().Question.OriginalAnswer == undefined ||
      this.dataSvc.currentQuestion().Question.OriginalAnswer == ""){
        this.dataSvc.currentQuestion().Question.OriginalAnswer = this.dataSvc.currentQuestion().Result.Selection;
      }

      this.dataSvc.IsAnswered(this.dataSvc.currentQuestion());

    var questionResponses = this.dataSvc.currentQuestion().QuestionResponses;
    if(questionResponses !== undefined && questionResponses !== null && questionResponses.length > 0){
      var response = questionResponses[0].Response;
      if(response !== null && response !== undefined){
        (<HTMLInputElement>document.getElementById("hfQuestion")).value = response.AnswerText;
        (<HTMLInputElement>document.getElementById("hfAnswer")).value = this.dataSvc.currentQuestion().Result.Selection;
        
        initiateDragDropQuestion();
        setInterval(() => {
            this.updateAnswer();
        },1000);
      }
    }
  }

  updateAnswer(){
    if(this.dataSvc.currentQuestion().Question.QuestionType === 7){
      this.dataSvc.IsAnswered(this.dataSvc.currentQuestion());
      if((<HTMLInputElement>document.getElementById("hfAnswer")) === undefined){
        clearInterval();
        return;
      }
      var elem = (<HTMLInputElement>document.getElementById("hfAnswer"));
      if(elem !== null && elem !== undefined){
        this.dragdropresponse = elem.value; 
        this.dataSvc.currentQuestion().Result.Selection = this.dragdropresponse;  
      }
      else{
        clearInterval();
        return;
      }
    }
    else{
      clearInterval();
      return;
    }
  }

 
}
